import React from 'react';
import { X, Trash2, AlertCircle } from 'lucide-react';
import { useTranslation } from '../../../contexts/LanguageContext';

const DeleteConfirmationModal = ({ space, onClose, onDelete, isLoading }) => {
  const { t } = useTranslation();
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="flex justify-between items-center border-b p-4">
          <h3 className="text-lg font-semibold">
            {t('sharesubs.modals.deleteConfirmation.title')}
          </h3>
          <button onClick={onClose}>
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>
        
        <div className="p-4">
          <div className="flex items-start mb-4">
            <AlertCircle className="h-5 w-5 text-red-500 mr-2 mt-0.5" />
            <div>
              <p className="font-medium">
                {t('sharesubs.modals.deleteConfirmation.description')}
              </p>
              <p className="text-gray-600 mt-1">
                {t('sharesubs.modals.deleteConfirmation.warning')}
              </p>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100"
            >
              {t('sharesubs.modals.deleteConfirmation.cancel')}
            </button>
            <button
              onClick={onDelete}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
              disabled={isLoading}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              {isLoading ? `${t('sharesubs.modals.deleteConfirmation.deleting')}...` : t('sharesubs.modals.deleteConfirmation.delete')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;